import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { EntityKey } from '@pma-entity/pma-entity-types';
import { Details } from '@details/Interfaces/details';
import { IDetailsResponse } from "@feature/_app_modules/mojo-details-widget/details-widget.types";

@Injectable()
export class MojoDetailsWidgetHttpService {
  private readonly apiBaseUrl: string;

  constructor(
    private readonly http: HttpClient,
    urlBuilder: UrlBuilderService) {
    this.apiBaseUrl = urlBuilder.getUrl('details');
  }

  getDetails(entityName: string, key: EntityKey | undefined): Observable<Details> {
    const url = `${this.apiBaseUrl}/data`;
    return this.http.post<IDetailsResponse>(url, { EntityViewName: entityName, OwnerEntityKey: key })
      .pipe(map(x => x.Details));
  }
}
